
import Student from './students'
export default class Clazz {
    public classId:string;
    public classCode:string;
    public className:string;
    public gradeId:string;
    public gradeCode:string;
    public gradeName:string;
    public zoneId:string;
    public zoneName:string;
    public students: Student[];
    constructor({
        classId = '',
        classCode = '',
        className = '',
        gradeId = '',
        gradeCode = '',
        gradeName = '',
        zoneId = '',
        zoneName = '',
        students = []
    }={}) {
        this.classId =classId ;
        this.classCode =classCode ;
        this.className =className ;
        this.gradeId =gradeId ;
        this.gradeCode =gradeCode ;
        this.gradeName = gradeName;
        this.zoneId = zoneId;
        this.zoneName = zoneName;
        this.students = students
    }
}